import { cloneDeep } from './clone';
/**
 * A simple cache to cache return values for primitive function inputs
 */
export class SimpleCache {
    static set(key, value) {
        this.cache.set(key, cloneDeep(value));
        return value;
    }
    static get(key) {
        const value = this.cache.get(key);
        return cloneDeep(value);
    }
    static clear() {
        this.cache.clear();
    }
}
SimpleCache.cache = new Map();
